
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { NewSearchService, AiSearchRequestModel, NewSearchResultModel } from '@app/services/new-search.service';
import { NewSearchResultComponent } from './new-search-result/new-search-result.component';
import { SpinnerComponent } from '@app/common-components/spinner/spinner.component';
@Component({
  selector: 'ai-search',
  imports: [FormsModule, NewSearchResultComponent, SpinnerComponent],
  templateUrl: './ai-search.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ai-search.component.css'
})
export class AiSearchComponent {
  prompt: string = '';
  public listings: NewSearchResultModel[] = [];
  public loading: boolean = false;

  constructor(private newSearchService: NewSearchService) {}

  onSubmit() {
    // Handle the search query submission
    console.log('Search submitted:', this.prompt);
    this.loading = true;
    const request: AiSearchRequestModel = { prompt: this.prompt };
    this.newSearchService.aiSearch(request).subscribe({
      next: (results: NewSearchResultModel[]) => {
        console.log('Search results:', results);
        // Handle the results as needed
        this.listings = results;
        this.loading = false;
      },
      error: (error) => {
        console.error('Error during AI search:', error);
        this.loading = false;
        // Handle the error as needed
      }
    });
  }
}
